// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stacked{
  top:0;
  transition: top ease 0.3s;
  position:relative;
  right:2px;
}
.stacked:hover {
  top: -10px;
}


.ticket {
  transition: all 0.4s ease-in-out;
}
.ticket:hover {
  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.15);
}

.ticket-row {
  border-color:#edeff1;
  border-style: dashed;
  border:1px dashed #edeff1;
  transition: all 0.2s ease-in-out;
  vertical-align: center;

}

.ticket-row:hover{
  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.05);
}

.ticket-table {
  width:90%;
  margin:auto;
  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.05);
}

.app_global_search{
  width: 320px;
  .search_input{
    font-size: 0.70rem;
  }
  .search_btn{
    width: 125px;
    font-size: 12px;
  }
}

.rounded-checkbox {
  border-radius: 50%!important;
  height:1rem!important;
  width:1rem!important;
  border: 1px solid #ddd;
  appearance: none;
  -webkit-appearance: none;
  outline: none;
}

.rounded-checkbox:checked {
  background-color: #ff4613;
}


.modal-big {
  width:1200px;
}



.custom-window-class > .modal-dialog,
.custom-window-class > .modal-dialog > .modal-content {
  width: 1200px!important;
  max-width: 1200px!important;
  min-width: 1200px!important;
}










.tab {
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.tab:after {
  content: '';
  display: block;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  position: absolute;
  background-color: #ff4612;
  transition: transform ease 200ms, opacity ease 0ms 200ms;
  transform: translateX(100%);
  opacity: 0;
}
.tabs-wrapper:hover .tabs:not(:hover) .tab:not(.active):first-child::after, .tab:hover ~ .tab:not(.active)::after {
  transform: translateX(-100%);
}
.tabs-wrapper:not(:hover) .tab:not(.active)::after {
  transform: translateY(100%);
}
.tabs:hover .tab:hover::after, .tabs-wrapper:hover .tabs:hover .tab:hover::after {
  transition-delay: 0ms, 0ms;
}
.tab.active::after, .tab:hover::after {
  transform: translateX(0%);
  opacity: 1;
}

p.tab {
  display: inline-block;
  text-decoration: none;
  color: #000;
  padding: 1rem;
}



.avatar-box{
  display:table-cell;
  vertical-align:middle;

}
.avatar {
  display: table-cell;
  vertical-align:middle;
  border-radius: 50%;
  text-align: center;
  font-weight: 600;
  color: #fff;
}

.avatar-sm{
  width:2vw;
  height:2vw;
  font-size:1vw;
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/containers/ticketing/components/ticket-status/ticket-status-table/ticket-status-table.component.css"],"names":[],"mappings":"AAAA;EACE,KAAK;EACL,yBAAyB;EACzB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,UAAU;AACZ;;;AAGA;EACE,gCAAgC;AAClC;AACA;EACE,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,yBAAyB;EACzB,gCAAgC;EAChC,sBAAsB;;AAExB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,YAAY;AACd;;;;AAIA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;;;;;;;;;;AAWA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,cAAc;EACd,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,wDAAwD;EACxD,2BAA2B;EAC3B,UAAU;AACZ;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,WAAW;EACX,aAAa;AACf;;;;AAIA;EACE,kBAAkB;EAClB,qBAAqB;;AAEvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;EACV,aAAa;AACf;;AAEA,g0JAAg0J","sourcesContent":[".stacked{\n  top:0;\n  transition: top ease 0.3s;\n  position:relative;\n  right:2px;\n}\n.stacked:hover {\n  top: -10px;\n}\n\n\n.ticket {\n  transition: all 0.4s ease-in-out;\n}\n.ticket:hover {\n  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.15);\n}\n\n.ticket-row {\n  border-color:#edeff1;\n  border-style: dashed;\n  border:1px dashed #edeff1;\n  transition: all 0.2s ease-in-out;\n  vertical-align: center;\n\n}\n\n.ticket-row:hover{\n  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.05);\n}\n\n.ticket-table {\n  width:90%;\n  margin:auto;\n  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.05);\n}\n\n.app_global_search{\n  width: 320px;\n  .search_input{\n    font-size: 0.70rem;\n  }\n  .search_btn{\n    width: 125px;\n    font-size: 12px;\n  }\n}\n\n.rounded-checkbox {\n  border-radius: 50%!important;\n  height:1rem!important;\n  width:1rem!important;\n  border: 1px solid #ddd;\n  appearance: none;\n  -webkit-appearance: none;\n  outline: none;\n}\n\n.rounded-checkbox:checked {\n  background-color: #ff4613;\n}\n\n\n.modal-big {\n  width:1200px;\n}\n\n\n\n.custom-window-class > .modal-dialog,\n.custom-window-class > .modal-dialog > .modal-content {\n  width: 1200px!important;\n  max-width: 1200px!important;\n  min-width: 1200px!important;\n}\n\n\n\n\n\n\n\n\n\n\n.tab {\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n}\n.tab:after {\n  content: '';\n  display: block;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 3px;\n  position: absolute;\n  background-color: #ff4612;\n  transition: transform ease 200ms, opacity ease 0ms 200ms;\n  transform: translateX(100%);\n  opacity: 0;\n}\n.tabs-wrapper:hover .tabs:not(:hover) .tab:not(.active):first-child::after, .tab:hover ~ .tab:not(.active)::after {\n  transform: translateX(-100%);\n}\n.tabs-wrapper:not(:hover) .tab:not(.active)::after {\n  transform: translateY(100%);\n}\n.tabs:hover .tab:hover::after, .tabs-wrapper:hover .tabs:hover .tab:hover::after {\n  transition-delay: 0ms, 0ms;\n}\n.tab.active::after, .tab:hover::after {\n  transform: translateX(0%);\n  opacity: 1;\n}\n\np.tab {\n  display: inline-block;\n  text-decoration: none;\n  color: #000;\n  padding: 1rem;\n}\n\n\n\n.avatar-box{\n  display:table-cell;\n  vertical-align:middle;\n\n}\n.avatar {\n  display: table-cell;\n  vertical-align:middle;\n  border-radius: 50%;\n  text-align: center;\n  font-weight: 600;\n  color: #fff;\n}\n\n.avatar-sm{\n  width:2vw;\n  height:2vw;\n  font-size:1vw;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
